import { Get } from "../utils/api";
import { useQuery } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";
import { Cart } from "../../types/api/Cart";

export default (sellerOrgId: string, buyerOrgId: string) => {
  const { getAccessTokenSilently } = useAuth0();

  // Only run query if both IDs exist and are not empty
  const shouldRunQuery = !!sellerOrgId && !!buyerOrgId &&
    sellerOrgId.trim() !== "" && buyerOrgId.trim() !== "";

  return useQuery(
    `current_cart_${sellerOrgId}_${buyerOrgId}`,
    async () => {
      return await Get<Cart>(
        `/api/cart/selling_organization/${sellerOrgId}/purchasing_organization/${buyerOrgId}`,
        await getAccessTokenSilently()
      );
    },
    {
      enabled: shouldRunQuery,
      // Don't retry if the query is disabled
      retry: shouldRunQuery
    }
  );
};
